import { useState } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const ChargeModal = ({ booking, card, onCharged, onClose }) => {
  const [amount, setAmount] = useState("");
  const [charging, setCharging] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const value = parseFloat(amount);
    if (!value || value <= 0) {
      toast.error("Enter a valid amount");
      return;
    }
    setCharging(true);
    try {
      const { data } = await api.post(
        `/admin/bookings/${booking.id}/charge`,
        { amount: value },
        { withCredentials: true }
      );
      toast.success(`Charged $${data.amount.toFixed(2)} to ${card.brand} •••• ${card.last4}`);
      onCharged();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Charge failed — try again.");
    } finally {
      setCharging(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-brand-navy/70 p-4 backdrop-blur-sm" onClick={onClose}>
      <form
        data-testid="charge-modal"
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-display text-lg font-extrabold text-brand-navy">Charge {booking.name}</h3>
            <p className="mt-1 text-xs font-semibold text-slate-500">
              {card.brand} •••• {card.last4} · exp {card.exp_month}/{card.exp_year}
            </p>
          </div>
          <button data-testid="charge-modal-close" type="button" onClick={onClose} className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100">
            <X className="h-5 w-5" />
          </button>
        </div>
        <label className="mt-5 block text-xs font-bold uppercase tracking-widest text-slate-500">Amount (USD)</label>
        <div className="mt-2 flex items-center rounded-xl border border-slate-200 bg-slate-50 px-4 focus-within:border-brand-blue">
          <span className="font-display text-xl font-extrabold text-slate-400">$</span>
          <input
            data-testid="charge-amount-input"
            type="number"
            min="0.50"
            step="0.01"
            required
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            className="w-full bg-transparent px-2 py-3.5 font-display text-xl font-extrabold text-brand-navy placeholder:text-slate-300 focus:outline-none"
          />
        </div>
        <button
          data-testid="charge-submit-button"
          type="submit"
          disabled={charging}
          className="mt-5 w-full rounded-xl bg-emerald-600 px-5 py-3.5 font-display text-sm font-extrabold uppercase tracking-widest text-white transition-transform hover:scale-[1.02] disabled:opacity-50"
        >
          {charging ? "Charging…" : `Charge card now`}
        </button>
      </form>
    </div>
  );
};
